import React from "react";

export default function Footer(){
    return(
        <footer>
            Made using React with TypeScript 2024 
        </footer>
    )
}